import { RouteRecordRaw } from 'vue-router';

import { landingSiteRouter } from './landing-site.router';
import { notFoundRoutes } from './shared';

/**
 * Marketing site routes (index.html entry).
 *
 * The business site's routes deliberately live in a separate module (business-routes.ts):
 * importing both from one file would put every booking view — and with them firebase, gsap,
 * lottie and PrimeVue — into the marketing bundle's module graph.
 */
export const landingRoutes: RouteRecordRaw[] = [
  ...landingSiteRouter,
  ...notFoundRoutes
];

export { registerRouterTracking, scrollBehavior } from './shared';
